/* eslint-disable no-undef */
// Environmental variables has to start with REACT_APP_ to be available for webpack
const baseUrl = process.env.REACT_APP_BASE_URL;

export default baseUrl;
